import { s } from '../lib/style.js';

export function Nav({ v, navRef }) {
  return (
    <nav
      ref={navRef}
      style={s("position:sticky;top:0;z-index:60;transition:transform .32s cubic-bezier(.4,0,.2,1);will-change:transform;background:rgba(255,255,255,0.62);backdrop-filter:blur(22px) saturate(1.8);-webkit-backdrop-filter:blur(22px) saturate(1.8);border-bottom:1px solid var(--line);")}
    >
      <div
        style={s("max-width:1220px;margin:0 auto;padding:14px 22px;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:16px 24px;")}
      >
        {' '}
        <a href="#top" style={s("display:flex;align-items:center;text-decoration:none;")}>
          {' '}
          <img src="/assets/brandbase-logo.webp" alt="BrandBase" style={s("height:24px;display:block;")} />
          {' '}
        </a>
        {' '}
        <div style={s(v.navRow)}>
          {' '}
          <a
            className="hv-1"
            href="#platform"
            style={s("text-decoration:none;color:var(--text);font-size:17px;font-weight:500;opacity:.72;")}
          >
            Solution
          </a>
          {' '}
          <a
            className="hv-1"
            href="#foundation"
            style={s("text-decoration:none;color:var(--text);font-size:17px;font-weight:500;opacity:.72;")}
          >
            Foundation
          </a>
          {' '}
          <a
            className="hv-1"
            href="#security"
            style={s("text-decoration:none;color:var(--text);font-size:17px;font-weight:500;opacity:.72;")}
          >
            Security
          </a>
          {' '}
          <a
            className="hv-1"
            href="#team"
            style={s("text-decoration:none;color:var(--text);font-size:17px;font-weight:500;opacity:.72;")}
          >
            Team
          </a>
          {' '}
          <a
            className="hv-1"
            href="#faq"
            style={s("text-decoration:none;color:var(--text);font-size:17px;font-weight:500;opacity:.72;")}
          >
            FAQ
          </a>
          {' '}
          <a
            className="hv-2"
            href="#waitlist"
            style={s("text-decoration:none;background:var(--navy);color:#FFFFFF;padding:10px 20px;border-radius:999px;font-size:16.5px;font-weight:500;letter-spacing:-0.01em;")}
          >
            {v.ctaLabel}
          </a>
          {' '}
        </div>
        {' '}
        <button type="button" aria-label="Menu" onClick={v.toggleNav} style={s(v.burgerBtn)}>
          {' '}
          <span aria-hidden="true" style={s(v.burgerTop)} />
          {' '}
          <span aria-hidden="true" style={s(v.burgerMid)} />
          {' '}
          <span aria-hidden="true" style={s(v.burgerBot)} />
          {' '}
        </button>
        {' '}
      </div>
      <div style={s(v.navDrawer)}>
        <div
          style={s("max-width:1220px;margin:0 auto;padding:6px 22px 20px;display:flex;flex-direction:column;gap:2px;")}
        >
          {' '}
          <a
            className="hv-3"
            href="#platform"
            onClick={v.closeNav}
            style={s("text-decoration:none;color:var(--text);font-size:18px;font-weight:500;padding:13px 4px;border-top:1px solid var(--line);")}
          >
            Solution
          </a>
          {' '}
          <a
            className="hv-3"
            href="#foundation"
            onClick={v.closeNav}
            style={s("text-decoration:none;color:var(--text);font-size:18px;font-weight:500;padding:13px 4px;border-top:1px solid var(--line);")}
          >
            Foundation
          </a>
          {' '}
          <a
            className="hv-3"
            href="#security"
            onClick={v.closeNav}
            style={s("text-decoration:none;color:var(--text);font-size:18px;font-weight:500;padding:13px 4px;border-top:1px solid var(--line);")}
          >
            Security
          </a>
          {' '}
          <a
            className="hv-3"
            href="#team"
            onClick={v.closeNav}
            style={s("text-decoration:none;color:var(--text);font-size:18px;font-weight:500;padding:13px 4px;border-top:1px solid var(--line);")}
          >
            Team
          </a>
          {' '}
          <a
            className="hv-3"
            href="#faq"
            onClick={v.closeNav}
            style={s("text-decoration:none;color:var(--text);font-size:18px;font-weight:500;padding:13px 4px;border-top:1px solid var(--line);")}
          >
            FAQ
          </a>
          {' '}
          <a
            className="hv-4"
            href="#waitlist"
            onClick={v.closeNav}
            style={s("margin-top:14px;text-align:center;text-decoration:none;background:var(--navy);color:#FFFFFF;padding:14px 22px;border-radius:999px;font-size:17px;font-weight:500;")}
          >
            {v.ctaLabel}
          </a>
          {' '}
        </div>
      </div>
    </nav>
  );
}
